<template>
	<page>
		<module>
			<view-list
				ref="view"
				:work-type="workType"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="商户信息">
							<c-input name="saas_info" placeholder="商户名称"></c-input>
						</m-search-item>
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="异常渠道">
							<c-select name="channel_id" async clearable @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="异常时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_ops_abnormal_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_ops_abnormal_handle')" prepend-icon="tf-check" @click="batchHandle()">确认处理</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<!--异常渠道：多标签展示，hover红圈显示同步失败原因-->
				<template #abnormal_channel_names="{data}">
					<div v-if="(data.abnormal_channel_list || []).length" class="m-abnormal-channels">
						<template v-for="(channel, i) in data.abnormal_channel_list">
							<span v-if="channel.sync_fail_reason" :key="i">
								{{channel.channel_name}}
								<c-tooltip :tip="channel.sync_fail_reason || ''">
									<i class="m-channel-info">!</i>
								</c-tooltip>
							</span>
							<span v-else :key="i">{{channel.channel_name}}</span>
						</template>
					</div>
					<span v-else>-</span>
				</template>

				<template #handle_state="{data}">
					<c-state async dict="ABNORMAL_PRODUCT_STATE" :value="data.handle_state"></c-state>
				</template>

				<!--操作栏：运营人员逐条处理，写法同超卖订单处理列表(130)-->
				<c-table-column
					type="button"
					label="操作"
					width="120"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_ops_abnormal_handle') && data.handle_state == 1" icon="tf-edit" @click="rowHandle(data)">处理</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!--批量处理弹框：异常处理说明（选填）-->
			<c-dialog ref="handleDialog" title="下架异常处理" width="520">
				<div class="m-handle-body">
					<div class="m-handle-tip">
						本次将提交处理 <b>{{pendingIds.length}}</b> 条异常记录，请确认已在渠道平台后台完成商品下架。
					</div>
					<div class="m-handle-remark">
						<p class="m-handle-remark-label">异常处理说明</p>
						<!--组件库 textarea 不认 rows 属性，行数用 height-resize 控制，120px 约四行-->
						<c-input v-model="handleRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '120px'}" placeholder="请输入异常处理说明（选填）"></c-input>
					</div>
				</div>
				<template #button>
					<c-button size="dialog" color="main" :disabled="isSubmitting" @click="submitHandle">确认处理</c-button>
					<c-button size="dialog" :disabled="isSubmitting" @click="$refs.handleDialog.close()">取消</c-button>
				</template>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'p_abnormal_list',

		data() {
			return {
				workType: 131,
				pendingIds: [],//待处理商品ID（打开弹框时固定）
				handleRemark: '',//异常处理说明
				isSubmitting: false//防止重复提交
			}
		},

		methods: {
			/*********搜索渠道（渠道是全平台共用的一份数据）**********/
			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********单条处理：只处理当前这一条，复用批量处理弹框（待处理状态才显示按钮）**********/
			rowHandle(data) {
				this.pendingIds = [data.id];
				this.handleRemark = '';
				this.$refs.handleDialog.open();
			},

			/*********批量确认处理：过滤待处理后打开说明弹框**********/
			batchHandle() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				if (!selected.length) {
					this.$message({message: '请先勾选需要处理的记录', type: 'warn'});
					return;
				}
				var validList = selected.filter(item => item.handle_state == 1);
				if (!validList.length) {
					this.$message({message: '请勾选【待处理】状态的记录', type: 'warn'});
					return;
				}
				this.pendingIds = validList.map(item => item.id);
				this.handleRemark = '';
				this.$refs.handleDialog.open();
			},

			/*********提交处理**********/
			submitHandle() {
				if (!this.pendingIds.length || this.isSubmitting) return;
				this.isSubmitting = true;
				this.request({
					url: '/ops/sale/product/abnormal/handle',
					data: {
						ids: this.pendingIds,
						handle_remark: this.handleRemark
					},
					loading: true,
					success: (data, msg) => {
						this.$refs.handleDialog.close();
						this.$message({message: msg, type: 'success'});
						this.$refs.view.update();
					},
					complete: () => {
						this.isSubmitting = false;
					},
					error: () => {
						this.isSubmitting = false;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}

	.m-abnormal-channels {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 12px;
		align-items: center;
		font-size: 13px;
		color: #333;
	}

	.m-channel-info {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		border: 1px solid #ed3f14;
		color: #ed3f14;
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		cursor: pointer;
		vertical-align: middle;
	}

	/*c-dialog 内容区默认无内边距，手动补一层（同超卖列表取消订单弹框的写法）*/
	.m-handle-body {
		padding: 16px 20px;
	}

	.m-handle-tip {
		margin-bottom: 12px;
		padding: 10px 12px;
		background: #fff7e6;
		border: 1px solid #ffe7ba;
		border-radius: 4px;
		font-size: 13px;
		line-height: 20px;
		color: #333;

		b {
			color: #fa8c16;
		}
	}

	.m-handle-remark {
		.m-handle-remark-label {
			margin-bottom: 8px;
			font-size: 13px;
			font-weight: bold;
			color: #333;
		}
	}
</style>
